import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Document, EntityType} from '@app/shared';
import {DocModalComponent} from '../doc-modal/doc-modal.component';
import {NzModalService} from 'ng-zorro-antd/modal';
import {DocumentService, isExpirationAlert, ScreenService} from '@app/core';
import {combineLatest, take} from 'rxjs';
import {NzDrawerService} from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-doc-info-card',
  standalone: false,

  templateUrl: './doc-info-card.component.html',
  styleUrl: './doc-info-card.component.less'
})
export class DocInfoCardComponent {

  @Input() document!: Document;
  @Input() isActive: boolean = false;
  @Input() isCompact: boolean = false;
  @Input() showOptions: boolean = true;
  @Input() showCheckbox: boolean = true;
  /** El análisis con IA sigue sin respuesta pasado el tiempo de espera. */
  @Input() aiStalled: boolean = false;
  @Input() entityId: number = 0;
  @Input() entityType: EntityType = 'Project';

  @Output() onActionBtnEvent: EventEmitter<string> = new EventEmitter<string>();

  correctDocsModalRef: any;
  uploadDocsDrawerRef: any;

  isMobile$;
  constructor(private modalService: NzModalService, public screenService: ScreenService,
              private drawerService: NzDrawerService, private documentService: DocumentService,) {
    this.isMobile$ = screenService.isMobile$;
  }
  onActionBtn(value: string): void {
    this.onActionBtnEvent.emit(value);
  }

  openCorrectDocModal(): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      if (isMobile) {
        this.uploadDocsDrawerRef = this.drawerService.create({
          nzClosable: false,
          nzMask: false,
          nzHeight: '98%',
          nzPlacement: 'bottom',
          nzContent: DocModalComponent,
          nzData: {
            docModalType: 'correct',
            document: this.document,
          }
        });

      } else {
        this.correctDocsModalRef = this.modalService.create({
          nzFooter: null,
          nzContent: DocModalComponent,
          nzAutofocus: null,
          nzClosable: false,
          nzCentered: true,
          nzWidth: 'auto'
        });

        this.correctDocsModalRef.getContentComponent().docModalType = 'correct';
        this.correctDocsModalRef.getContentComponent().document = this.document;
        this.correctDocsModalRef.getContentComponent().entityId = this.entityId;
        this.correctDocsModalRef.getContentComponent().entityType = this.entityType;
      }
    });
  }

  openDoc() {
    this.documentService.openDocumentInNewTab(this.document);
  }


  protected readonly isExpirationAlert = isExpirationAlert;
}
